// src/services/searchService.ts
import { api } from './api';
import { Task } from 'types/task';
import { FileMovement } from 'types/fileMovement';

export interface MatchedUser {
  _id: string;
  name: string;
  email: string;
  role: string;
  department?: string;
}

export interface SearchResult {
  tasks: Task[];
  matchedUsers: MatchedUser[];
  matchedFiles: FileMovement[];
}

export const searchService = {
  search: async (q: string): Promise<SearchResult> => {
    const { data } = await api.get('/search', { params: { q } });
    return data;
  },
};
